import { ListViewWrapper, Button } from '@ami/react/core';
import { CreateButton, TableActions } from '@ami/react/core';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { ordersService } from './ordersService';
import { appConfig } from '@ami/react/core';
import { OrderFilter } from './filterConfiguration';
import OrderFilterComponent from './components/list/OrderFilterComponent';
import { pagination } from '@ami/react/core';
import { getLoginData, getGenericData, saveGenericData, downloadWithFallback } from '@ami/react/core';
import { isAmiUserAuthorizedToCreateOrders } from '../authorization/amiPermissions';
import Table from './components/list/OrderTable';
import moment from 'moment';
import queryString from 'query-string';
import { orderStatus } from '../orders/order';
import { User } from '../users/user';
import Item from '../Item';
//import './OrderListPage.scss';

const filterStorageKey = 'orders-list-filters';

class OrderListPage extends React.Component {
  constructor() {
    super();
    this.search = this.search.bind(this);
    this.handleBottomScroll = this.handleBottomScroll.bind(this);
  }

  state = {
    items: [],
    filter: this.initializeFilter(),
    amiUsers: [],
    statuses: [],
    loading: true,
    hasLoadedAllPages: false,
    initialDealerBranchSearch: null,
    page: 0,
    downloadingCsv: false,
  };

  initializeFilter() {
    const saved = getGenericData(filterStorageKey);
    if (saved && saved.startDate) saved.startDate = moment(saved.startDate);
    if (saved && saved.endDate) saved.endDate = moment(saved.endDate);
    if (saved && saved.shipDateStartDate) saved.shipDateStartDate = moment(saved.shipDateStartDate);
    if (saved && saved.shipDateEndDate) saved.shipDateEndDate = moment(saved.shipDateEndDate);
    return saved ? new OrderFilter(saved) : new OrderFilter();
  }

  search() {
    saveGenericData(filterStorageKey, this.state.filter);
    this.loadPage(0);
  }

  handleBottomScroll() {
    if (!this.state.hasLoadedAllPages) {
      this.loadPage(this.state.page + 1);
    }
  }

  loadPage(page) {
    if (!this.state.loading) {
      this.setState({ loading: true, page });
    }
    ordersService.searchOrders(this.state.filter, page).then((items) =>
      this.setState({
        items: page === 0 ? items : this.state.items.concat(items),
        hasLoadedAllPages: items.length < pagination.pageSize,
      })
    )
    .catch(() => { })
    .finally(() => this.setState({ loading: false }));
  }

  async componentDidMount() {
    const queryStringObj = queryString.parse(this.props.location.search);
    if (appConfig.isManagementApp && 'my-orders' in queryStringObj) {
      const loginData = getLoginData();
      if (loginData) {
        const { filter } = this.state;
        filter.contactAmiUserId = loginData.userData.id;
        this.setState({ filter }, () => this.search());
      }
    } else if (appConfig.isManagementApp && 'all-orders' in queryStringObj) {
      const { filter } = this.state;
      filter.contactAmiUserId = null;
      this.setState({ filter }, () => this.search());
    } else {
      this.search();
    }
    const statuses = [
      new Item(orderStatus.cancelled.id, orderStatus.cancelled.label),
      new Item(orderStatus.pending.id, orderStatus.pending.label),
      new Item(
        orderStatus.shippingCompleted.id,
        orderStatus.shippingCompleted.label
      ),
    ];
    this.setState({ statuses });

    if (appConfig.isManagementApp) {
      const amiUsers = await User.search();
      this.setState({ amiUsers });
    }
  }

  async downloadDetailsCsv() {
    this.setState({ downloadingCsv: true });
    ordersService.downloadDetailsCsv(this.state.filter).then((blob) => {
      downloadWithFallback(blob, 'OrderDetails.csv');
      this.setState({ downloadingCsv: false });
    });
  }

  render() {
    const { downloadingCsv } = this.state;
    return (
      <ListViewWrapper
        title="Orders"
        buttons={[
          isAmiUserAuthorizedToCreateOrders() ? (
            <CreateButton
              text="New Order"
              onCreate={() => this.props.history.push('/orders/create')}
            />
          ) : null,
          <Button
            key="2"
            type="button"
            className="btn-primary ms-3 my-2"
            label={downloadingCsv ? 'Exporting' : 'Export Details CSV'}
            onClick={() => this.downloadDetailsCsv()}
            showSpinner={downloadingCsv}
            disabled={downloadingCsv}
            iconName="download"
          />,
        ]}
      >
        <TableActions>
          <OrderFilterComponent
            filter={this.state.filter}
            amiUsers={this.state.amiUsers}
            statuses={this.state.statuses}
            onChange={(x) => this.setState({ filter: new OrderFilter(x) })}
            onFilter={this.search}
            initialDealerBranchSearch={this.state.initialDealerBranchSearch}
          />
        </TableActions>
        <Table
          onBottomScroll={this.handleBottomScroll}
          orders={this.state.items}
          loading={this.state.loading}
        />
      </ListViewWrapper>
    );
  }
}

const OrderList = withRouter(OrderListPage);
export { OrderList };
